import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { downgradedAngularModule } from 'src/ajs-app/app';
import { InboxComponent } from 'src/app/care/inbox/inbox/inbox.component';
import { LeftNavigationComponent } from 'src/app/care/inbox/left-navigation/left-navigation.component';
import { CountersService } from 'src/app/care/inbox/services/counters.service';
import { NavigationService } from 'src/app/care/inbox/services/navigation.service';
import { TabsNavigationComponent } from 'src/app/care/inbox/tabs-navigation/tabs-navigation.component';
import { TaskActionsService } from 'src/app/care/inbox/task-actions/task-actions.service';

downgradedAngularModule
  .directive('angularInbox', downgradeComponent({ component: InboxComponent }))
  .directive('angularLeftNavigation', downgradeComponent({ component: LeftNavigationComponent }))
  .directive('angularTabsNavigation', downgradeComponent({ component: TabsNavigationComponent }))
  .factory('AngularCountersService', downgradeInjectable(CountersService))
  .factory('AngularNavigationService', downgradeInjectable(NavigationService))
  .factory('AngularTaskActionsService', downgradeInjectable(TaskActionsService));
